import React, { useEffect, useState } from 'react';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate } from 'react-router-dom';
import { Table, Spinner, Modal, Button, Form } from 'react-bootstrap';
import RefershIcon from '../../../common/assets/images/reload.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPenToSquare, faTrash } from '@fortawesome/free-solid-svg-icons';
import axiosInstance from '../../../axiosinterceptor';

const RoleManagement = () => {
    const navigate = useNavigate();
    const permissions = JSON.parse(sessionStorage.getItem('permissions'));

    useEffect(() => {
        if (permissions && !permissions.admin) {
            navigate('/no-access');
        }
    }, [permissions, navigate]);

    const [roles, setRoles] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [editingRole, setEditingRole] = useState(null);
    const [roleName, setRoleName] = useState('');
    const [deletingRole, setDeletingRole] = useState(null);
    const [refresh, setRefresh] = useState(false);

    useEffect(() => {
        const fetchRoles = async () => {
            setIsLoading(true);
            try {
                const response = await axiosInstance.get("/getAdminRolesACS");
                setRoles(response.data.data);
            } catch (error) {
                // console.error('Error fetching roles:', error);
                toast.error(error.response?.data?.message || "Error fetching roles.");

            }
            setIsLoading(false);
        };
        fetchRoles();
    }, [refresh]);

    const handleShowModal = (role = null) => {
        // console.log("handleShowModal called with role:", role); // Add this line
         setEditingRole(role);
        setRoleName(role ? role.role_name : '');
        setShowModal(true);
    };

    const handleSave = async () => {
        // console.log(editingRole ? "Editing Role:" : "Adding New Role:", roleName);

        if (!roleName.trim()) {
            toast.error('Role name cannot be empty!');
            return;
        }

        const isDuplicate = roles.some(
            (role) =>
                role?.role_name?.toLowerCase() === roleName.toLowerCase() &&
                (!editingRole || role?.role_id !== editingRole?.role_id)
        );

        if (isDuplicate) {
            toast.error('Role name already exists!');
            return;
        }

        if (editingRole) {
            try {
                const response = await axiosInstance.put(`/updateAdminRolesACS`, {
                    newRoleName: roleName,
                    newupdatedBy: sessionStorage.userId,
                    roleId: editingRole.role_id,
                });
                // console.log("Successfully edited:", roleName);
                toast.success(response.data.message);
                setRoles((prev) =>
                    prev.map((role) =>
                        role?.role_id === editingRole.role_id ? { ...role, role_name: roleName } : role
                    )
                );
            } catch (error) {
                // console.error('Error updating role:', error);
                toast.error(error.response?.data?.message || "Failed to update role.");
            }
        } else {
            try {
                const response = await axiosInstance.post("/PostAdminRolesACS", {
                    roleName: roleName,
                    createdBy: sessionStorage.userId,
                });
                // console.log("Successfully added:", roleName);
                toast.success(response.data.message);
                setRoles((prev) => [...prev, response.data.data]);
            } catch (error) {
                // console.error('Error adding role:', error);
                // toast.error('Failed to add role');
                toast.error(error.response?.data?.message || "Failed to add role.");

            }
        }

        setShowModal(false);
        setRefresh(!refresh);
    };

    const handleShowDeleteModal = (role) => {
        setDeletingRole(role);
        setShowDeleteModal(true);
    };

    const handleDelete = async () => {
        if (!deletingRole) return;

        // console.log("Deleting Role:", deletingRole.role_name);

        try {
            const response = await axiosInstance.delete(`/deleteAdminRolesACS?roleId=${deletingRole.role_id}`);
            // console.log("Successfully deleted:", deletingRole.role_name);
            toast.success(response.data.message);

            setRoles((prev) => prev.filter((role) => role?.role_id !== deletingRole.role_id));
        } catch (error) {
            // console.error('Error deleting role:', error);
            // toast.error('Failed to delete role');
            toast.error(error.response?.data?.message || "Failed to update role.");

        }

        setShowDeleteModal(false);
        setRefresh(!refresh);
    };

    const handleRefresh = () => {
        setRefresh(!refresh);
    };

    return (
        <div className="userlist-section">
            <ToastContainer autoClose={5000} />
            <div className="userlist-header">
                <h4 className="userlist-header-text">Roles</h4>
                <div className="userlist-filter-section">
                    <button className="userlist-filter-btn" onClick={() => handleShowModal()}>
                        Add Role
                    </button>
                    <span className="userlist-refresh-btn" onClick={handleRefresh}>
                        <span>
                            <img src={RefershIcon} alt="Refresh" />
                        </span>
                    </span>
                </div>
            </div>
            <div className="userlist-table-container">
                <Table responsive="sm" style={{ textAlign: 'center' }} className="userlist-filter-table">
                    <thead className="userlist-thead">
                        <tr className="userlist-tr">
                            <th className="userlist-th">Role ID</th>
                            <th className="userlist-th">Role Name</th>
                            <th className="userlist-th">Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {isLoading ? (
                            <tr>
                                <td colSpan="3">
                                    <div className="userlist-table-loader">
                                        <Spinner />
                                    </div>
                                </td>
                            </tr>
                        ) : roles && roles.length > 0 ? (
                            roles.map((role) => (
                                role && role.role_id ? ( //Conditional check added here
                                    <tr key={role.role_id}>
                                        <td className="userlist-td">{role.role_id}</td>
                                        <td className="userlist-td">{role.role_name}</td>
                                        <td className="userlist-td">
                                            <FontAwesomeIcon
                                                icon={faPenToSquare}
                                                className="iconuser-update"
                                                onClick={() => handleShowModal(role)}
                                            />
                                            <FontAwesomeIcon
                                                icon={faTrash}
                                                className="iconuser-update"
                                                onClick={() => handleShowDeleteModal(role)}
                                            />
                                        </td>
                                    </tr>
                                ) : null
                            ))
                        ) : (
                            <tr>
                                <td colSpan="3">
                                    <p className="mb-0">No Records Found</p>
                                </td>
                            </tr>
                        )}
                    </tbody>
                </Table>
            </div>

            <Modal show={showModal} onHide={() => setShowModal(false)} centered>
                <Modal.Header closeButton>
                    <Modal.Title>{editingRole ? 'Edit Role' : 'Add Role'}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Form.Group>
                            <Form.Label>Role Name:</Form.Label>
                            <Form.Control
                                type="text"
                                value={roleName}
                                onChange={(e) => setRoleName(e.target.value)}
                                placeholder="Role Name"/>
                                </Form.Group>
                            </Form>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="secondary" onClick={() => setShowModal(false)}>
                                Cancel
                            </Button>
                            <Button variant="success" onClick={handleSave}>
                                {editingRole ? 'Update' : 'Save'}
                            </Button>
                        </Modal.Footer>
                    </Modal>
        
                    <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)} centered>
                        <Modal.Header closeButton>
                            <Modal.Title>Confirm Delete</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            Are you sure you want to delete the role "<b>{deletingRole?.role_name}</b>"?
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="secondary" onClick={() => setShowDeleteModal(false)}>
                                Cancel
                            </Button>
                            <Button variant="success" onClick={handleDelete}>
                                Delete
                            </Button>
                        </Modal.Footer>
                    </Modal>
                </div>
            );
        };
        
        export default RoleManagement;